import axios from 'axios';
const CancelToken = axios.CancelToken;

export default function getCancelToken() {
    return CancelToken.source();
}